import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import {
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_ENABLED,
  GOOGLE_MAPS_LIBRARIES,
} from "../../../config/googleMaps";

const GoogleMapsWrapperLoaded = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    id: "sr-google-maps-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: "en",
    region: "US",
  });

  if (!isLoaded) return <div>Loading Map...</div>;
  return <>{children}</>;
};

const GoogleMapsWrapper = ({ children }) =>
  GOOGLE_MAPS_ENABLED ? (
    <GoogleMapsWrapperLoaded>{children}</GoogleMapsWrapperLoaded>
  ) : (
    <>{children}</>
  );

export default GoogleMapsWrapper;
